import React, { useEffect } from "react";
import { Form, Modal, Radio } from "antd";

function RadioPicker({
  className,
  form,
  name,
  label,
  width,
  labelCol,
  required,
  errorMessage,
  validateFunction,
  defaultValue,
  options,
  onChange,
  disabled,
  onChangeConfMsg
}) {

  useEffect(() => {
    if (defaultValue?.toString()) {
      form.setFieldsValue({ [name]: defaultValue });
    }
  }, []);

  const onChangeConfirmation = (e) => {
    if(!onChangeConfMsg) return;
    if(e.target.value === defaultValue) return;
    Modal.confirm({
      title: onChangeConfMsg.text,
      okText: onChangeConfMsg.okButtonLabel,
      cancelText: onChangeConfMsg.cancelButtonLabel,
      cancelButtonProps: { danger: true, type: 'primary' },
      // okButtonProps: {  },
      onOk: () => {form.setFieldsValue({ [name]: e.target.value })},
      onCancel: () => {form.setFieldsValue({ [name]: defaultValue })}
    });
  }


  return (
    <Form.Item
      className={className}
      name={name}
      label={label}
      labelCol={{ span: labelCol ? labelCol : 8 }}
      style={{ width: width, fontWeight: 600 }}
      rules={[
        {
          required: required,
          message: errorMessage,
        },
        () => ({
          validator(rule, value) {
            return validateFunction
              ? validateFunction(rule, value)
              : Promise.resolve();
          },
        }),
      ]}
    >
      <Radio.Group
        disabled={disabled}
        defaultValue={defaultValue}
        style={{ fontWeight: 600, width: "100%" }}
        onChange={onChange}
      >
        {options.map((opt, index) => {
          return (
            <Radio key={index} value={opt.value} style={{ fontWeight: 600 }} onChange={onChangeConfirmation}>
              {opt.label}
            </Radio>
          );
        })}
      </Radio.Group>
    </Form.Item>
  );
}

export default RadioPicker;
